import { FC } from 'react';
import { ICaremapNote, ICaremapNoteResponse } from '../notes/model/NotesClient';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CommentsModelFactory } from './CommentsModelFactory';
import { useSubscription } from '@meraki-internal/state';
import { CommunityAvatar } from '../community/CommunityAvatar';
import { CommentViewer } from './CommentViewer';

export type ICommentListProps = {
    post: ICaremapNote;
};

export const CommentList: FC<ICommentListProps> = ({ post }) => {

    const factory = useInstance(CommentsModelFactory);
    useSubscription(() => factory);

    const model = factory.forNote(post);
    const comments = [...model.getComments()].sort((c1, c2) => c2.createdAt.localeCompare(c1.createdAt));

    const startEditing = (comment: ICaremapNoteResponse) => {
        model.startEditing(comment);
    };

    const deleteComment = async (comment: ICaremapNoteResponse) => {
        await model.deleteComment(comment);
    };

    return (
        <>
            {comments.map(comment => (
                <div
                    key={comment.noteId}
                    data-type="comment"
                    data-id={`comment-${comment.noteId}`}
                    style={{display: 'flex', alignItems: 'flex-start', gap: 15, margin: '20px 0px 20px 10px'}}
                >
                    <div>
                        <CommunityAvatar
                            size={36}
                            pictureUrl={comment.createdByUser?.pictureUrl}
                            firstName={comment.createdByUser?.firstName}
                            lastName={comment.createdByUser?.lastName}
                        />
                    </div>
                    <div style={{flexGrow: 100}}>
                        <CommentViewer
                            comment={comment}
                            editHandler={model.canEdit(comment) ? startEditing : undefined}
                            deleteHandler={model.canDelete(comment) ? deleteComment : undefined}
                        />
                    </div>
                </div>
            ))}
        </>
    );
};
